export default "__VITE_ASSET__c9fnBnNu__"